import axiosInstance from '../utils/axios-instance'

export const customerService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post('/customer', data)
      return response.data
    } catch (error) {
      throw error
    }
  },

  fetch: async (limit, skip) => {
    try {
      const response = await axiosInstance.get(
        `/customer?$limit=${limit || 10}&$skip=${skip || 0}`
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/customer/${id}`, data)
      return response.data
    } catch (error) {
      throw error
    }
  },

  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/customer/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
